module.exports = __webpack_public_path__ + "img/profile-oscar.55638b88.webp";